import React, { Suspense, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import DOMPurify from 'dompurify';
import { useTheme } from 'ThemeContext';
import { ReactSVG } from 'react-svg';
import LoadingData from 'components/LoadingData';
import {
  Wrapper,
  Box,
  ItemHolder,
  Item,
  Featured,
  Star,
  Imagebox,
  Image,
  Source,
  Details,
  Title1,
  Text,
  Link,
  Arrow,
  MoreLink
} from './ArticlesGridNew.style';
import { Breakpoints } from 'assets/Variables.style';
import { AppSettingsContext } from 'AppSettingsContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-regular-svg-icons';

import IMAGE_PLACEHOLDER_MAIN from 'assets/Images/placeholder-640x480.png';
import IMAGE_PLACEHOLDER_ALT from 'assets/Images/placeholder-248x186.png';
import Title from '../Title';
function ArticlesGridNew({
  articles = [],
  readMoreLinkColor,
  subtitle = '',
  title = '',
  titleColor = undefined,
  titleBackground = undefined,
  linkBackground = undefined,
  linkColor = undefined,
  slug = '',
  linkText = '',
  firstReadMoreLinkColor,
  isReverted
}) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  const renderItemInner = (article, key) => {
    const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
    let currentImage = article.thumbnail || article.image;
    let currentImageTablet;
    let currentImageMobile;
    let currentImageMatch;
    if (currentImage) {
      currentImageMatch = currentImage.match(regExp);
      if (currentImageMatch && currentImageMatch[1] && currentImageMatch[2]) {
        currentImage = `${currentImageMatch[1]}_${
          key === 0
            ? theme.articlesGridNew.image.main.width
            : theme.articlesGridNew.image.width
        }x${
          key === 0
            ? theme.articlesGridNew.image.main.height
            : theme.articlesGridNew.image.height
        }${currentImageMatch[2]}`;
        currentImageTablet = `${currentImageMatch[1]}_${
          key === 0
            ? theme.articlesGridNew.image.main.widthTablet
            : theme.articlesGridNew.image.widthTablet
        }x${
          key === 0
            ? theme.articlesGridNew.image.main.heightTablet
            : theme.articlesGridNew.image.heightTablet
        }${currentImageMatch[2]}`;
        currentImageMobile = `${currentImageMatch[1]}_${
          key === 0
            ? theme.articlesGridNew.image.main.widthMobile
            : theme.articlesGridNew.image.widthMobile
        }x${
          key === 0
            ? theme.articlesGridNew.image.main.heightMobile
            : theme.articlesGridNew.image.heightMobile
        }${currentImageMatch[2]}`;
      }
    }

    return (
      <>
        <Imagebox
          theme={theme.articlesGridNew.imagebox}
          main={key === 0 ? String(true) : undefined}
        >
          {currentImageTablet && (
            <Source
              media={`(max-width: ${Breakpoints.md}px)`}
              srcSet={currentImageTablet}
            />
          )}
          {currentImageMobile && (
            <Source
              media={`(max-width: ${Breakpoints.sm}px)`}
              srcSet={currentImageMobile}
            />
          )}
          <Image
            theme={theme.articlesGridNew.image}
            src={
              currentImage ||
              (key === 0 ? IMAGE_PLACEHOLDER_MAIN : IMAGE_PLACEHOLDER_ALT)
            }
            alt={article.title}
            main={key === 0 ? String(true) : undefined}
          />
          {article.isFeatured ? (
            <Featured
              theme={theme.articlesGridNew.featured}
              main={key === 0 ? String(true) : undefined}
            >
              {theme.articlesGridNew.featured.shape && (
                <ReactSVG
                  className='shape'
                  src={theme.articlesGridNew.featured.shape}
                />
              )}
              <Star
                theme={theme.articlesGridNew.star}
                main={key === 0 ? String(true) : undefined}
              >
                <Suspense fallback={<LoadingData fullmode={true} />}>
                  <FontAwesomeIcon icon={faStar} />
                </Suspense>
              </Star>
              {(key === 0 && theme.articlesGridNew.featured.main.isText) ||
              (key !== 0 && theme.articlesGridNew.featured.isText) ? (
                <FormattedMessage id='ARTICLES_GRID.WORTH_TO_SEE' />
              ) : (
                ''
              )}
            </Featured>
          ) : (
            ''
          )}
        </Imagebox>
        <Details
          theme={theme.articlesGridNew.details}
          main={key === 0 ? String(true) : undefined}
        >
          <Title1
            theme={theme.articlesGridNew.title}
            main={key === 0 ? String(true) : undefined}
          >
            {article.title}
            {key !== 0 && !theme.articlesGridNew.link.isText ? (
              <Arrow theme={theme.articlesGridNew.arrow}>
                <FontAwesomeIcon icon={theme.articlesGridNew.arrow.faIcon} />
              </Arrow>
            ) : (
              ''
            )}
          </Title1>
          {key === 0 || theme.articlesGridNew.text.show ? (
            //first
            <Text
              theme={theme.articlesGridNew.text}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(article.text)
              }}
            />
          ) : (
            ''
          )}
          {(key === 0 && theme.articlesGridNew.link.main.isText) ||
          (key === 0 && theme.articlesGridNew.link.isText) ? (
            <Link
              firstReadMoreLinkColor={firstReadMoreLinkColor}
              theme={theme.articlesGridNew.link}
              main={key === 0 ? String(true) : undefined}
            >
              <FormattedMessage id='ARTICLES_GRID.MORE' />
              <Arrow
                theme={theme.articlesGridNew.arrow}
                main={key === 0 ? String(true) : undefined}
              >
                <FontAwesomeIcon
                  icon={
                    key === 0
                      ? theme.articlesGridNew.star.main.faIcon
                      : theme.articlesGridNew.star.faIcon
                  }
                />
              </Arrow>
            </Link>
          ) : (
            ''
          )}
          {(key !== 0 && theme.articlesGridNew.link.main.isText) ||
          (key !== 0 && theme.articlesGridNew.link.isText) ? (
            <Link
              readMoreLinkColor={readMoreLinkColor}
              theme={theme.articlesGridNew.link}
              main={key === 0 ? String(true) : undefined}
            >
              <FormattedMessage id='ARTICLES_GRID.MORE' />
              <Arrow
                theme={theme.articlesGridNew.arrow}
                main={key === 0 ? String(true) : undefined}
              >
                <FontAwesomeIcon
                  icon={
                    key === 0
                      ? theme.articlesGridNew.star.main.faIcon
                      : theme.articlesGridNew.star.faIcon
                  }
                />
              </Arrow>
            </Link>
          ) : (
            ''
          )}
        </Details>
      </>
    );
  };

  return (
    <Wrapper theme={theme.articlesGridNew.wrapper}>
      <Box
        theme={theme.articlesGridNew.box}
        reverted={isReverted === true ? String(true) : undefined}
      >
        <Title
          title={title}
          subtitle={subtitle}
          titleColor={titleColor}
          titleBackground={titleBackground}
          linkBackground={linkBackground}
          linkColor={linkColor}
          linkText={linkText}
          slug={appSettings.theme === 6 ? '' : slug}
          themeOverrideText={theme.title.textWidget2}
        />
        {articles &&
          articles.map((article, key) => (
            <ItemHolder
              key={key}
              theme={theme.articlesGridNew.itemHolder}
              main={key === 0 ? String(true) : undefined}
              reverted={isReverted === true ? String(true) : undefined}
            >
              {key === 0 && theme.articlesGridNew.itemHolder.shape && (
                <ReactSVG
                  className='shape'
                  src={theme.articlesGridNew.itemHolder.shape}
                />
              )}
              {(article.slug && /(http(s?)):\/\//gi.test(article.slug)) ||
              (article.url && /(http(s?)):\/\//gi.test(article.url)) ||
              article.url_outside ? (
                <Item
                  theme={theme.articlesGridNew.item}
                  href={article.slug || article.url || article.url_outside}
                  target={
                    article._blank ||
                    article.url_blank ||
                    article.url_outside_blank
                      ? '_blank'
                      : '' || article.target || ''
                  }
                  rel={
                    article.nofollow ||
                    article.url_nofollow ||
                    article.url_outside_nofollow
                      ? 'nofollow'
                      : '' || article.rel || ''
                  }
                >
                  {renderItemInner(article, key)}
                </Item>
              ) : (
                <Item
                  theme={theme.articlesGridNew.item}
                  smooth
                  to={
                    article.slug &&
                    (article.slug[0] === '/' || article.slug[0] === '#')
                      ? article.slug
                      : `/${article.slug}`
                  }
                  main={key === 0 ? String(true) : undefined}
                >
                  {renderItemInner(article, key)}
                </Item>
              )}
            </ItemHolder>
          ))}
      </Box>
      {appSettings.theme === 6 && slug ? (
        <MoreLink
          to={slug}
          linkBackground={linkBackground}
          linkColor={linkColor}
          theme={theme.title.link}
        >
          {linkText ? linkText : <FormattedMessage id='TITLE.ALL_ARTICLES' />}
        </MoreLink>
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default ArticlesGridNew;
